import { z } from 'zod';
import { publicUserSchema } from './user.js';
/**
 * Az oleles atirata.
 *
 * ─── Miert a BONGESZO veszi fel a hangot, es nem a media-szerver? ─────────────
 *
 * A kezenfekvo ut a LiveKit "egress" volna: a szerver kivezeti a szoba hangjat
 * egy fajlba. Ket okbol nem azt valasztottuk:
 *
 *  1. **Ki beszel?** Az egress egyetlen, OSSZEKEVERT hangsavot ad. Abbol a
 *     beszelok szetvalasztasa (diarizacio) kulon, hibas felismeresre hajlamos
 *     lepes - es egy atirat, amiben nem tudni, ki mit mondott, tobbet art, mint
 *     hasznal. Ha viszont MINDENKI a sajat mikrofonjat veszi fel, a beszelo
 *     nem talalgatas kerdese, hanem adat.
 *  2. **Nem kell hozza uj infrastruktura.** Az egress kulon konteneert, kulon
 *     Redis-kapcsolatot es sajat S3-beallitast kivan, es ma nincs beallitva.
 *     A bongeszo felvetele a meglevo fajlfeltoltesi uton megy.
 *
 * Az ara: ha valakinek a bongeszoje osszeomlik, az O hangjabol elveszhet az
 * utolso darab. Ezt vallaljuk - a darabok folyamatosan mennek fel, tehat
 * legfeljebb par masodpercrol van szo.
 *
 * ─── Miert FOLYAMATOSAN, es nem a hivas vegen? ───────────────────────────────
 *
 * A hang darabokban megy fel es darabokban dolgozzuk fel, meg a hivas alatt:
 * igy az atirat masodpercekkel a hivas utan kesz (nem percekkel), a gep
 * terhelese elosztott (nem egy csucs a hivas vegen), es egy megszakadas
 * legfeljebb egy darabot visz el.
 */
// ─── Alapertelmezes ───────────────────────────────────────────────────────────
/**
 * Csatornaban alapbol BE, privat beszelgetesben alapbol KI.
 *
 * Egy csatorna-oleles munkamegbeszeles: ott az atirat a kozos emlekezet. Egy
 * DM viszont ketten folytatott beszelgetes; annak a felvetele kulon dontes
 * legyen, ne alapertelmezes.
 */
export function defaultTranscribe(kind) {
    return kind !== 'dm' && kind !== 'group_dm';
}
// ─── Felvetel ─────────────────────────────────────────────────────────────────
/**
 * Ekkora darabokban megy fel a hang.
 *
 * A rovidebb darab gyorsabb atiratot ad es kevesebbet veszit egy szakadaskor,
 * de tobb keresert es tobb feldolgozasi inditasert fizet - es a darabok hataran
 * elvagott mondat felismerese romlik. A fel perc korul jo az egyensuly.
 */
export const TRANSCRIPT_CHUNK_MS = 25_000;
/** Egy darab felso merethatara. Opusszal ~30 mp bosegesen belefer. */
export const TRANSCRIPT_CHUNK_MAX_BYTES = 4 * 1024 * 1024;
/**
 * Alsó hatarok: ez ala nincs mit atirni.
 *
 * ─── Mi ez a hiba, amit megelozunk? ─────────────────────────────────────────
 *
 * A felvetel a mikrofonnal egyutt indul es all le, ezert MINDEN nemitas egy
 * darabot lezar. Aki visszakapcsol, nem szol, es ujra nemit, azzal egy olyan
 * blobot kuld fel, amiben csak a WebM-fejlec van, hangkeret alig - a felismero
 * pedig ezt nem tudja megnyitni: "Failed to decode audio.".
 *
 * Elesben ez ugy latszott, hogy az atirat helyenkent hianyos, a hibajelentoben
 * meg gyultek az 500-as valaszok. A darab sosem lesz jo, barhanyszor
 * megprobaljuk - ezert nem ujraprobalni kell, hanem fel sem kuldeni.
 *
 * ─── Miert ket kulon hatar? ─────────────────────────────────────────────────
 *
 * A HOSSZ a valodi merce: egy masodperc alatt nincs ertelmes mondat. A meret
 * csak halo az olyan darabra, ami hosszunak latszik, de nincs benne hang (pl.
 * a felvetel elakadt) - ezert szandekosan nagyon alacsony: egy csupasz fejlec
 * nehany szaz bajt, mig egy valodi, akar halk masodperc is tobb kilobajt.
 * Igy a halk beszed nem esik aldozatul.
 */
export const TRANSCRIPT_CHUNK_MIN_MS = 1_000;
export const TRANSCRIPT_CHUNK_MIN_BYTES = 1_024;
/**
 * A rogzitheto formatumok - es az, hogy melyik milyen kiterjesztesu.
 *
 * ─── Miert erdekli ez a szervert? ───────────────────────────────────────────
 *
 * A felismero a fajl NEVEBOL is kovetkeztet a formatumra. Ha egy Ogg-darabot
 * `chunk.webm` neven kuldunk be, a dekoder nem tudja megnyitni - es pontosan
 * ugyanazt a "Failed to decode audio." hibat kapjuk, mint egy serult fajlnal.
 *
 * A bongeszok kozott van kulonbseg: van, amelyik WebM-et ad, van, amelyik
 * Oggot. Amig a csapat Chrome-ot hasznal, ez nem latszik - egyetlen mas
 * bongeszo viszont az ILLETO TELJES atiratat elvinne, csendben.
 *
 * Ezert a darab magaval hozza a sajat formatumat, es itt van egyetlen helyen,
 * hogy melyiket fogadjuk el. A lista a felvevo `MIME_CANDIDATES` sorrendjet
 * koveti.
 */
export const TRANSCRIPT_MIME_TYPES = {
    'audio/webm;codecs=opus': 'webm',
    'audio/webm': 'webm',
    'audio/ogg;codecs=opus': 'ogg',
    'audio/ogg': 'ogg',
    'audio/mp4': 'mp4',
};
/** A regi kliensek nem kuldik a formatumot - ok WebM-et rogzitettek. */
export const DEFAULT_TRANSCRIPT_MIME = 'audio/webm';
export const transcriptMimeSchema = z.enum(Object.keys(TRANSCRIPT_MIME_TYPES));
/** A felismerohoz kuldott fajlnev. A kiterjesztes NEM diszites: abbol dolgozik. */
export function transcriptFileName(mimeType) {
    const ext = TRANSCRIPT_MIME_TYPES[mimeType] ?? 'webm';
    return `chunk.${ext}`;
}
export const transcriptChunkStates = ['pending', 'done', 'failed'];
export const transcriptChunkStateSchema = z.enum(transcriptChunkStates);
// ─── Az atirat ────────────────────────────────────────────────────────────────
export const transcriptSegmentSchema = z.object({
    id: z.string(),
    /** Ki beszelt. A sajat mikrofon-felvetelbol tudjuk, nem talalgatasbol. */
    userId: z.string().nullable(),
    /**
     * TELEFONOS szakasz: a hivo aga. Ilyenkor `userId` ures, a nev a
     * `speakerLabel` (a hivo szama).
     */
    phoneLegId: z.string().nullable().default(null),
    /** A beszelo neve, ha nem felhasznalo. A megjelenites ezt veszi elore. */
    speakerLabel: z.string().nullable().default(null),
    /** A hivas kezdetetol eltelt ido - ebbol all ossze a kozos idovonal. */
    startMs: z.number(),
    endMs: z.number(),
    /** A felismero NYERS szovege. Ezt sosem irjuk felul. */
    text: z.string(),
    /**
     * A nyelvi modell altal atnezett valtozat, ha keszult.
     *
     * `null` = nem valtozott, vagy nem volt atnezes. A felulet ilyenkor a nyers
     * szoveget mutatja - es az eredetire mindig vissza lehet kapcsolni.
     */
    polishedText: z.string().nullable(),
});
/**
 * Az atirat allapota.
 *
 * KIMONDOTT allapot, nem kikovetkeztetett: ha a felulet csak annyit tudna,
 * hogy "nincs szoveg", nem tudna megkulonboztetni a meg keszulot a
 * bukottol - es a felhasznalo egy ures oldalt nezne, talalgatva.
 */
export const transcriptStates = [
    /** Nem keszult atirat errol a hivasrol (ki volt kapcsolva). */
    'off',
    /** A hivas meg tart, a felvetel megy. */
    'recording',
    /** A hivas veget ert, meg vannak feldolgozatlan darabok. */
    'processing',
    'ready',
    /** Minden darab elbukott - itt NEM lesz atirat, es ezt meg kell mondani. */
    'failed',
];
export const transcriptStateSchema = z.enum(transcriptStates);
export const transcriptSchema = z.object({
    huddleId: z.string(),
    channelId: z.string(),
    title: z.string().nullable(),
    startedAt: z.string(),
    endedAt: z.string().nullable(),
    state: transcriptStateSchema,
    /** Hany darab var meg feldolgozasra. `processing` allapotban ez a hatralevo. */
    pendingChunks: z.number(),
    /**
     * Hany darab bukott el veglegesen.
     *
     * Kimondjuk, meg ha az atirat egyebkent kesz is: egy hianyos atirat, ami
     * teljesnek latszik, rosszabb, mint egy hianyos atirat, amirol tudjuk, hogy
     * hianyos.
     */
    failedChunks: z.number(),
    segments: z.array(transcriptSegmentSchema),
    /** Akik reszt vettek - ok latjak az atiratot kulon megosztas nelkul is. */
    participants: z.array(publicUserSchema),
    /** Atnezte-e mar nyelvi modell. */
    polishedAt: z.string().nullable(),
    /** Ha az atnezes elbukott: a konkret ok. */
    polishError: z.string().nullable(),
    /** Akikkel kesobb megosztottuk. */
    sharedWith: z.array(publicUserSchema),
    /**
     * Akiktol EGYALTALAN NEM erkezett hang.
     *
     * Bent voltak a hivasban, de a bongeszojuk egy darabot sem toltott fel -
     * mert vegig nemitva voltak, mert nem tud rogziteni, vagy mert a feltoltes
     * elakadt. Enelkul ez lathatatlan hiba: az atirat "keszen" all, csak eppen
     * valakinek a mondatai hianyoznak belole, es semmi nem szol rola.
     */
    missingAudio: z.array(publicUserSchema),
});
// ─── Bemenetek ────────────────────────────────────────────────────────────────
export const huddleTranscribeInput = z.object({ enabled: z.boolean() });
export const transcriptShareInput = z.object({
    userIds: z.array(z.string().min(1)).min(1).max(50),
});
export const transcriptSearchQuery = z.object({
    q: z.string().trim().min(2).max(200),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
/** Vesszovel elvalasztott hivas-azonositok - a folyamban lathato olelesek. */
export const transcriptStatesQuery = z.object({
    huddleIds: z.string().min(1).max(4000),
});
export const transcriptHitSchema = z.object({
    huddleId: z.string(),
    channelId: z.string(),
    title: z.string().nullable(),
    startedAt: z.string(),
    segment: transcriptSegmentSchema,
});
// ─── Megjelenites ─────────────────────────────────────────────────────────────
/** `mm:ss` (vagy `h:mm:ss`) a hivas kezdetetol. */
export function formatOffset(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const ss = String(seconds).padStart(2, '0');
    // Ora nelkul `m:ss`, oraval `h:mm:ss` - egy tizperces hivasnal a vezeto nulla
    // csak zaj lenne.
    return hours > 0 ? `${hours}:${String(minutes).padStart(2, '0')}:${ss}` : `${minutes}:${ss}`;
}
/**
 * A szakasz beszeloje: a telefonos hivonak a sajat cimkeje (a szama), a
 * kollegaknak a nevuk. Minden megjelenites ezen at nevez - igy a telefonos
 * hivo sehol nem lesz "Ismeretlen".
 */
export function speakerName(segment, nameOf) {
    return segment.speakerLabel ?? nameOf(segment.userId);
}
/**
 * Az atirat sima szovegge alakitva - ezt lehet tovabbkuldeni.
 *
 * Szandekosan a legegyszerubb, mindenhol olvashato alak: idobelyeg, nev,
 * szoveg. Egy feladatkezelo, egy level vagy egy jegyzet ugyanugy elfogadja.
 */
export function transcriptToText(transcript, nameOf) {
    const head = `${transcript.title ?? 'Ölelés'} — ${new Date(transcript.startedAt).toLocaleString('hu-HU')}`;
    const lines = transcript.segments.map((segment) => `[${formatOffset(segment.startMs)}] ${speakerName(segment, nameOf)}: ${segment.text}`);
    return [head, '', ...lines].join('\n');
}
//# sourceMappingURL=transcript.js.map